import { MessageContext } from 'fluent/compat';
import React from 'react';
import _ from 'lodash';

export const getQuantityElements = quantities => (
  quantities.map((quantity, i) => (
    <span key={`${quantity.type + i}`} className="dib w4 silver">
      {[quantity.count, quantity.type].join(' ')}
    </span>
  ))
);

export const getQuantities = (task) => {
  const types = new MessageContext('en-US');
  types.addMessages(`
sets = {$count ->
  [1]   set
 *[00] sets
}
repeats = {$count ->
  [1]   repeats
 *[00] repeats
}
reps = {$count ->
  [1]   rep
 *[00] reps
}
seconds = {$count ->
  [1]   second
 *[00] seconds
}
minutes = {$count ->
  [1]   minute
 *[00] minutes
}
hours = {$count ->
  [1]   hour
 *[00] hours
}
perDay = per day
  `);
  const counts = new MessageContext('en-US');
  counts.addMessages(`
repeats = {$count}
sets = {$count}
reps = {$count}
seconds = {$count}
minutes = {$count}
hours = {$count}
perDay = {$count}x
  `);
  const quantities = [];
  const push = (type, count) => {
    if (count && types.getMessage(type)) {
      quantities.push({
        type: types.format(types.getMessage(type), { count }),
        count: counts.format(counts.getMessage(type), { count }),
      });
    }
  };
  if (task.quantityType === 'REPS') {
    push('sets', task.sets);
    push('reps', task.reps);
  } else if (task.quantityType === 'DURATION') {
    push('repeats', task.sets);
    push(task.durationType.toLowerCase(), task.duration);
  }
  push('perDay', task.times);

  return quantities;
};

export const getFormDescription = (count, description) => {
  const questions = new MessageContext('en-US');
  questions.addMessages(`
questions = {$count ->
   [1] question
  *[00] questions
}
  `);
  return ([
    <span className="db silver" key="description">{description}</span>,
    <span className="db mt1 silver" key="count">
      {`
        ${count}
        ${questions.format(questions.getMessage('questions'), { count })}
      `}
    </span>,
  ]);
};

export const isVimeoPlayerUrl = videoUrl => (
  videoUrl.includes('player.vimeo.com/external')
);

export const formatVimeoPlayerUrl = (videoUrl) => {
  const match = videoUrl.match(/\d+/);
  return `https://vimeo.com/${match[0]}`;
};

const getValueType = (value) => {
  if (typeof value === 'number') {
    return 'integer';
  }
  return typeof value;
};

export const mapAnswerValues = (answer) => {
  if (answer) {
    const answerValueType = answer.valueType || getValueType(answer.value);
    const answerValue = answer.valueType === 'integer' ? parseInt(answer.value, 10) : answer.value;
    return ({ [`value${_.startCase(answerValueType)}`]: answerValue });
  }
  return ({
    valueString: '',
  });
};
